import { cn } from '@/lib/cn';

interface AdminBadgeProps {
  /** admin_role 값 — super / content / readonly / null */
  role?: string | null;
  className?: string;
}

/**
 * 관리자/운영자 배지 — 작성자 닉네임 옆에 노출.
 *  - super    → [관리자] 빨강 톤 (rise 토큰)
 *  - content  → [운영자] 파랑 톤 (primary 토큰)
 *  - readonly → 표시 안 함 (내부 모니터링용 롤)
 *  - null     → 표시 안 함
 *
 * 배지 크기는 LevelBadge 와 동일한 라인(h-5/text-[11px])으로 맞춰 줄 떨림 방지.
 */
export function AdminBadge({ role, className }: AdminBadgeProps) {
  if (!role) return null;
  if (role === 'super') {
    return (
      <span
        className={cn(
          'inline-flex h-5 shrink-0 items-center rounded px-1.5 text-[11px] font-bold leading-none',
          'bg-[color-mix(in_srgb,var(--color-rise)_12%,transparent)] text-[var(--color-rise)]',
          className,
        )}
      >
        관리자
      </span>
    );
  }
  if (role === 'content') {
    return (
      <span
        className={cn(
          'inline-flex h-5 shrink-0 items-center rounded px-1.5 text-[11px] font-bold leading-none',
          'bg-[color-mix(in_srgb,var(--color-primary)_12%,transparent)] text-[var(--color-primary)]',
          className,
        )}
      >
        운영자
      </span>
    );
  }
  return null;
}
